import { isEmpty, isUndefined } from 'lodash-es';
import { type PropsWithChildren } from 'react';

import { HoneycombHive } from './HoneycombHive.js';
import { HoneycombLegendRenderer } from './legend/HoneycombLegendRenderer.js';
import { ChartLayout } from '../../core/components/chart-layout/ChartLayout.js';
import { useAutoLegendRefresh } from '../../core/components/chart-layout/hooks/useAutoLegendRefresh.js';
import { getChartStatesTemplates } from '../../core/components/chart-states/utils/get-chart-states-template.js';
import { DEFAULT_HONEYCOMB_WIDTH } from '../constants.js';
import { graphContainer } from '../HoneycombChart.sty.js';
import { useHoneycombData } from '../hooks/use-honeycomb-data.js';
import { useHoneycombLegendConfig } from '../hooks/use-honeycomb-legend-config.js';
import type { HoneycombChartProps } from '../types/honeycomb.js';

export const HoneycombChartLayout = (
  props: PropsWithChildren<HoneycombChartProps>,
) => {
  const {
    data,
    width = DEFAULT_HONEYCOMB_WIDTH,
    loading = false,
    children,
    'data-dtrum-mask': dataDtrumMask,
    'data-dtrum-allow': dataDtrumAllow,
  } = props;
  const filteredData = useHoneycombData();
  const legendConfig = useHoneycombLegendConfig();
  const chartLayoutRef = useAutoLegendRefresh(data);

  const { emptyState, errorState } = getChartStatesTemplates(children);

  return (
    <ChartLayout
      ref={chartLayoutRef}
      chartWidth={width}
      chartHeight={'100%'}
      isEmpty={isEmpty(filteredData)}
      emptyState={emptyState}
      errorState={errorState}
      showLoader={loading}
      data-dtrum-mask={dataDtrumMask}
      data-dtrum-allow={dataDtrumAllow}
    >
      <ChartLayout.Graph>
        <div className={graphContainer}>
          <HoneycombHive />
        </div>
      </ChartLayout.Graph>
      {!isUndefined(legendConfig) && !legendConfig.hidden && (
        <ChartLayout.Legend
          position={legendConfig.position}
          ratio={legendConfig.ratio}
          onResize={legendConfig.onRatioChange}
        >
          <HoneycombLegendRenderer />
        </ChartLayout.Legend>
      )}
    </ChartLayout>
  );
};

HoneycombChartLayout['displayName'] = 'HoneycombChartLayout';
